<template>
  <div>
    <b-alert variant="danger" :show="error !== null" class="mb-3">{{ error }}</b-alert>

    <form ref="form">
      <payment-card-form ref="stripeCardForm" :disabled="saving"/>

      <h5>Billing Address</h5>

      <organization-billing-form-inputs :organization="organization"
                                        @organizationParamsChange="organizationAddress = arguments[0]"
                                        @stripeParamsChange="stripeAddress = arguments[0]"/>

      <b-row class="mt-4 mb-2">
        <b-col class="ml-auto" cols="auto">
          <b-button variant="light"
                    class="btn-rounded"
                    @click="$emit('cancel')">
            CANCEL
          </b-button>

          <b-button variant="primary"
                    class="btn-rounded px-3"
                    @click="createPaymentMethod"
                    :disabled="saving">
            <span v-if="saving">PLEASE WAIT...</span>
            <span v-else>SAVE</span>
          </b-button>
        </b-col>
      </b-row>
    </form>
  </div>
</template>
<script>

import PaymentCardForm from "../Payments/PaymentCardForm.vue";
import OrganizationBillingFormInputs from "../Billing/OrganizationBillingFormInputs.vue";
import normalize from "json-api-normalize";
import Attributes from "../../../models/Attributes.js";
import GeneralMixins from "../../../mixins/GeneralMixins.js";

export default {
  components: {OrganizationBillingFormInputs, PaymentCardForm},
  mixins: [GeneralMixins],
  props: {
    organization: {
      type: Object,
      required: true
    },
    paymentMethodsUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      error: null,
      saving: false,
      organizationAddress: null,
      stripeAddress: null,
      updateBillingAddress: true
    }
  },

  methods: {
    createPaymentMethod() {
      if (!this.$refs.form.reportValidity()) {
        return
      }

      if (this.$refs.stripeCardForm.localError) {
        this.error = this.$refs.stripeCardForm.localError;
        return;
      }

      if (this.updateBillingAddress && this.organizationAddress) {
        this.$http.patch("/customers/organization", this.organizationAddress).then(fulfilled => {
          // Billing info was updated
        }, rejected => {
          this.setError(this.getErrorMessagesHtml(rejected.body))
        })
      }

      const stripe = this.$refs.stripeCardForm.stripe;
      const card = this.$refs.stripeCardForm.card;
      const name = this.$refs.stripeCardForm.ccName;

      if (stripe) {
        this.saving = true;
        stripe.createPaymentMethod({
          type: 'card',
          card: card,
          billing_details: {
            name: name,
            address: this.stripeAddress
          }
        }).then((result) => {
          if (result.error && result.error.message) {
            this.saving = false;
            this.error = result.error.message;
          } else {
            this.error = null;
            this.$http.post(this.paymentMethodsUrl, {
              payment_method: {
                stripe_id: result.paymentMethod.id
              }
            }).then(fulfilled => {
              this.error = null;
              this.showToast("Payment method was successfully added");
              const paymentMethod = normalize(fulfilled.body).get(Attributes.paymentMethodAttributes);
              this.$emit('success', paymentMethod);
            }, rejected => {

              if (rejected.body && rejected.body.errors) {
                this.error = this.getErrorMessages(rejected.body.errors)[0]
              } else {
                this.error = "There was an error while adding this payment method";
              }
            }).then(() => this.saving = false);
          }
        });
      }
    }
  }
}
</script>